import { lazy } from "react";

const ApiKeysPage = lazy(() => import("./pages/ApiKeysPage"));

export const apiKeyRoutes = [
  {
    path: "api-keys",
    element: <ApiKeysPage />,
    handle: {
      label: "API Keys",
      title: "API Keys",
      icon: "key-round",
      protected: true,
    },
  },
];
